/* Corps d'un article du Journal. Une entrée de `body` est soit une chaîne de texte,
   soit un objet typé. Le prérendu (scripts/prerender.js) et la page React
   (src/pages/Journal.js) appellent tous deux `corpsHtml()` : ce que lit le robot et
   ce que voit le visiteur sortent du même fabricant.

   Deux rendus seulement diffèrent par l'habillage des paragraphes : le HTML servi
   garde le `<p>` nu du prérendu d'origine, l'écran garde la classe et les marges
   déjà en place. Aucun libellé, aucune URL n'est écrit ici : les boutons lisent
   `ctas_guide` de src/data/navigation.json. */

const esc = (s) =>
  String(s == null ? "" : s)
    .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

/* Adresse attendue de chaque variante de bouton. Le libellé et l'URL réellement
   rendus restent ceux de `ctas_guide` ; cette table ne sert qu'à retrouver l'entrée. */
const VARIANTES_CTA = { brief: "/brief/", estimer: "/estimer/" };

export const VARIANTES = Object.keys(VARIANTES_CTA);

/* `[texte](/chemin/)` devient un lien interne. Le texte est échappé avant, donc le
   motif ne peut plus porter de balise. Tout chemin qui ne commence pas par « / »
   (http, https, mailto, javascript, relatif) n'est pas reconnu et reste du texte. */
const liens = (texteEchappe) =>
  texteEchappe.replace(/\[([^\]]+)\]\((\/[^\s()]*)\)/g, (_, libelle, chemin) =>
    `<a href="${chemin}">${libelle}</a>`);

const paragraphe = (texte, visiteur, i) => {
  if (!visiteur) return texte ? `<p>${liens(esc(texte))}</p>` : "";
  const marge = i === 0 ? "0" : "16px";
  return `<p class="t-body" style="margin-top:${marge}">${liens(esc(texte))}</p>`;
};

const bouton = (item, ctas) => {
  const variante = item.variante;
  const cible = VARIANTES_CTA[variante];
  if (!cible) return "";
  const cta = (ctas || []).find((c) => c.to === cible);
  if (!cta) return "";
  return `<p class="article-cta"><a href="${cta.to}" class="article-btn-${variante === "brief" ? "nuit" : "ligne"}"` +
    ` data-testid="journal-cta-${variante}">${esc(cta.l)}</a></p>`;
};

const tableau = (item, i) => {
  const entetes = Array.isArray(item.entetes) ? item.entetes : [];
  const lignes = Array.isArray(item.lignes) ? item.lignes : [];
  if (!entetes.length || !lignes.length) return "";
  if (lignes.some((l) => !Array.isArray(l) || l.length !== entetes.length)) return "";
  return `<div class="article-cadre"><table class="article-tableau" data-testid="journal-tableau-${i}">` +
    `<thead><tr>${entetes.map((c) => `<th scope="col">${esc(c)}</th>`).join("")}</tr></thead>` +
    `<tbody>${lignes
      .map((l) => `<tr>${l.map((c, j) => (j === 0
        ? `<th scope="row">${esc(c)}</th>`
        : `<td>${esc(c)}</td>`)).join("")}</tr>`)
      .join("")}</tbody></table></div>`;
};

const element = (item, ctas, visiteur, i) => {
  if (typeof item === "string") return paragraphe(item, visiteur, i);
  if (!item || typeof item !== "object") return "";
  if (item.type === "cta") return bouton(item, ctas);
  if (item.type === "tableau") return tableau(item, i);
  return "";
};

/* `visiteur` à vrai reprend la classe et les marges de la page React. */
export function corpsHtml(body, ctas, visiteur = false) {
  return (body || []).map((item, i) => element(item, ctas, visiteur, i)).join("");
}

export function sectionsArticleHtml(sections, ctas, visiteur = false) {
  return (sections || [])
    .map((sec) => `<section><h2>${esc(sec.h2)}</h2>${corpsHtml(sec.body, ctas, visiteur)}</section>`)
    .join("");
}
